<template>
  <div id="smallHeaderMainMenu" class="container">
    <b-row class="no-gutters smallMainMenu">
      <b-col class="col menuBtn">
        <fa-icon
          class="iconSize mt-2"  
          icon="home"
          @click="navigateToPage('Home')"
        />
      </b-col>
      <b-col class="col menuBtn">
        <fa-icon
          class="iconSize mt-2"  
          icon="book-open"
          @click="navigateToPage('Parts Catalog')"
        />
      </b-col>
      <b-col class="col menuBtn">
        <fa-icon
          class="iconSize mt-2"  
          icon="file-invoice-dollar"
          @click="navigateToPage('Orders')"
        />
      </b-col>
      <b-col class="col menuBtn">
        <fa-icon
          class="iconSize mt-2"
          icon="arrow-circle-left"
          @click="navigateToPage('Claims & Returns')"
        />
      </b-col>
      <b-col class="col menuBtn">
        <fa-icon
          class="iconSize mt-2"
          icon="file-import"
          @click="navigateToPage('Quick Order')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { homedir } from "os";
  import { controlsHelper } from "@/components/mixins/commonControlsHelper"

  export default {    
    mixins: [controlsHelper],
    data: () => ({
      menuItem: "Navigate to ... ",
      mainMenuList: [ "Home", "Parts Catalog", "Orders", "Claims & Returns", "Deal of the Day", "Quick Order"  ]
    }),
    methods: {
      navigateToPage(page) {
        switch(page) {
        case "Home":
          this.clickEvent("/");
          break;
        case "Parts Catalog":
          this.clickEvent("/catalog/catalogListing");
          break;
        case "Orders":
          this.clickEvent("/orders/openOrders");
          break;
        case "Claims & Returns":
          this.clickEvent("/rvsc/Index");
          break;
        case "Quick Order": 
          this.clickEvent("/orders/quickorders");
          break;
        default:
          break;
        }
      }
    }
  }
</script>

<style>
  .smallMainMenu {
    margin-top: -30px;
    background-color: #dbe1e9;
    background-image: linear-gradient(to bottom, #dbe1e9, #babfc5);
    background-repeat: repeat-x;
    text-align: center;
    border: 1px solid grey;
    border-radius: 3px;    
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25), inset 0 -1px 0 rgba(0, 0, 0, 0.1);
    height: 3rem;
  }

  .iconSize {
    font-size: 2em; 
  }

  .dnIconSize {
    font-size: 2.8rem;
  }

  .menuBtn {
    border-right: 2px groove #e3e3e3;
    height: auto;
  }
</style>